import React from 'react';
import cutthroatLogo from '../images/CUTTHROAT logo.png';

export const Footer = () => {
  return (
    <footer className="bg-black text-white relative pt-16 pb-8 border-t-8 border-yellow-400">
      {/* Jagged Top Overlay */}
      <div className="absolute top-[-20px] left-0 w-full h-8 bg-gradient-to-r from-yellow-400 to-yellow-600 clip-jagged transform rotate-180 z-20"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end gap-8">
          {/* Brand */}
          <div className="transform -rotate-1">
            <img src={cutthroatLogo} alt="CUTTHROAT Logo" className="h-20 w-auto object-contain mb-2" />
            <p className="font-marker text-gray-400 text-lg">The Ultimate All Fives Dominoes Experience.</p>
          </div>

          {/* Socials */}
          <div className="flex gap-4">
            <a href="https://instagram.com/CutthroatDominoes" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-yellow-400 bg-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors transform hover:-rotate-12">
              <iconify-icon icon="ri:instagram-line" width="20" color="#eab308"></iconify-icon>            </a>
            <a href="https://x.com/CutthroatDominoes" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-yellow-400 bg-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors transform hover:rotate-12">
              <iconify-icon icon="ri:twitter-x-line" width="20" color="#eab308"></iconify-icon>
            </a>
            <a href="https://tiktok.com/@CutthroatDominoes" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-yellow-400 bg-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors transform hover:-rotate-12">
              <iconify-icon icon="simple-icons:tiktok" width="20" color="#eab308"></iconify-icon>
            </a>
          </div>

          {/* Newsletter (Ransom Note Style) */}
          <div className="w-full md:w-auto">
            <div className="flex flex-wrap gap-1 items-center font-anton text-xl uppercase mb-2">
              <span className="bg-white text-black px-1 transform rotate-2">Join</span>
              <span className="bg-red-600 text-white px-1 transform -rotate-3">The</span>
              <span className="bg-gray-800 text-white px-1 transform rotate-1">Calling</span>
              <span className="bg-yellow-400 text-black px-1 transform -rotate-2">Card</span>
            </div>
            <form className="flex relative group">
              <input
                type="email"
                placeholder="Email Address..."
                className="bg-transparent border-b-2 border-white text-white font-sans py-2 px-1 focus:outline-none w-full md:w-64 placeholder-gray-500"
              />
              <button type="button" className="absolute right-0 bottom-2 text-yellow-400 hover:text-white transition-colors">
                <iconify-icon icon="solar:plain-linear" width="24"></iconify-icon>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 text-center md:text-left border-t border-gray-800 pt-8 font-mono text-xs text-gray-500">
          <p>© 2026 Cutthroat Dominoes Master. All rights reserved.</p>
        </div>
      </div>

      {/* Bottom Corner Decor */}
      <div className="absolute bottom-0 right-0 w-32 h-32 bg-halftone opacity-20 clip-slant-left pointer-events-none"></div>
    </footer>
  );
};
